import { render, staticRenderFns } from "./SurveyRecords.vue?vue&type=template&id=259e92d4&"
import script from "./SurveyRecords.vue?vue&type=script&lang=js&"
export * from "./SurveyRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports